<template src="./template.html"></template>

<script>
export default {
  name: "HomeNews",
  data() {
    return {
      news_data: []
    }
  },
  methods: {
    async GetNewsoData() {
      let result = await this.SendGetData(process.env.VUE_APP_BASE_API + 'news/get_news_list.php')
      if (result != "error") {
        console.log()
        this.news_data = JSON.parse(result.data)
        this.news_data = this.news_data.slice(0, 5)
      }
    }
  },
  created() {
    this.GetNewsoData()
  }
}
</script>